export default function PageHero({ title, sub, bg = "#003d2b", page }) {
  return (
    <div
      className="relative overflow-hidden px-4 sm:px-10 pt-14 sm:pt-[72px] pb-12 sm:pb-[60px]"
      style={{ background: bg }}
    >
      <svg
        className="absolute inset-0 w-full h-full opacity-[0.05]"
        viewBox="0 0 1200 300"
        preserveAspectRatio="xMidYMid slice"
      >
        {Array.from({ length: 6 }).map((_, r) =>
          Array.from({ length: 16 }).map((_, c) => (
            <circle
              key={`${r}-${c}`}
              cx={c * 90 + 45}
              cy={r * 60 + 30}
              r="20"
              fill="none"
              stroke="#fff"
              strokeWidth="1"
            />
          ))
        )}
      </svg>
      <div className="relative z-[2] max-w-container mx-auto">
        <div className="text-xs text-white/50 mb-2.5 tracking-[0.08em]">
          Home {page ? `› ${page}` : ""}
        </div>
        <h1 className="font-serif text-[32px] sm:text-[44px] font-extrabold text-white leading-[1.2] mb-3 animate-fadeIn">
          {title}
        </h1>
        {sub && (
          <p className="text-white/70 text-[15px] sm:text-base max-w-[560px]">
            {sub}
          </p>
        )}
      </div>
    </div>
  );
}
